import {
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { memo, useEffect, useState } from "react";
import SwitchERP from "../../../../components/basics/Switch";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";
import FinanceCategoryCheckBox from "./FinanceCheckBox";
import LoadingCheckBox from "./LoadingCheckBox";

const FinanceGroupDrawer = () => {
  const {
    filters,
    clearAllFinanceFilter,
    isDrawerOpen,
    setDrawerOpen,
    cachedFinanceCategories,
    loadingCostCenter,
    applyFinanceFilter,
    setGroupByFinanceCategory,
  } = useResultadoExercicioService();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (cachedFinanceCategories.length) {
      const parentCategories = cachedFinanceCategories.filter(
        (category) => !category.parentId
      );
      setCategories(parentCategories);
    }
  }, [cachedFinanceCategories]);

  return (
    <Drawer
      open={isDrawerOpen}
      anchor="right"
      onClose={() => {
        setDrawerOpen(false);
        applyFinanceFilter();
      }}
    >
      <Grid
        container
        direction="column"
        style={{
          width: 480,
          height: "100%",
          maxHeight: "100vh",
          flexWrap: "nowrap",
        }}
      >
        <Grid
          item
          aria-label="drawer-header"
          style={{
            padding: 16,
            borderBottom: "1px solid #dddddd",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <IconButton
            onClick={() => {
              setDrawerOpen(false);
              applyFinanceFilter();
            }}
            size="small"
          >
            <Close />
          </IconButton>
          <Typography variant="h6"> Categorias do Financeiro</Typography>
        </Grid>
        <Grid
          container
          item
          xs
          direction="column"
          style={{
            padding: 32,
          }}
        >
          <Grid
            item
            container
            direction="row"
            alignItems="center"
            style={{ paddingBottom: 32 }}
          >
            <Grid item xs component={Typography}>
              Agrupar resultados por Grupo de Categorias
            </Grid>
            <Grid item>
              <SwitchERP
                value={filters.groupByFinanceCategory}
                onChange={(event) =>
                  setGroupByFinanceCategory(event.target.checked)
                }
              />
            </Grid>
          </Grid>

          <Divider style={{ marginBottom: 16 }} />
          <Grid item>
            <Typography variant="h6">Filtrar categoria</Typography>
          </Grid>
          <Grid
            item
            xs
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {loadingCostCenter
              ? Array(8)
                  .fill(<LoadingCheckBox />)
                  .map((loadingSkeleton) => loadingSkeleton)
              : categories.map((item) => (
                  <FinanceCategoryCheckBox
                    financeCategory={item}
                    level={0}
                    key={item.id}
                  />
                ))}
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            padding: "16px",
            borderTop: "1px solid #dddddd",
            gap: "16px",
          }}
          container
        >
          <Grid item xs>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={async () => {
                setDrawerOpen(false);
                applyFinanceFilter();
              }}
            >
              Aplicar
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => clearAllFinanceFilter(cachedFinanceCategories)}
            >
              Limpar tudo
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default memo(FinanceGroupDrawer);
